import { createSelector } from '@ngrx/store';

import { selectDecoratorsState } from './decorators.selector';

export const getDocumentContent = createSelector(
  selectDecoratorsState,
  ({ documentContent }): string => documentContent
);
